// extracted by mini-css-extract-plugin
export var formContainer = "_c1-0";
export var message = "_c1-1";